export default __webpack_public_path__ + "3f244708c9909decf69656d236394d07.png";